export default "__VITE_ASSET__Dsxgb$qL__"